"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _types = require("../types");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_mui.Alert)(({
  theme
}) => ({
  marginBottom: theme.spacing(2)
}));
const Notification = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    closeCallback,
    notificationMessage
  } = props;
  const {
    closeEnabled,
    closeLabel,
    id,
    linkText,
    linkUrl,
    type,
    text
  } = notificationMessage;
  const severity = (0, _utils.getAlertSeverity)(type);
  const handleCloseNotification = (0, _react.useCallback)(() => {
    closeCallback(id);
  }, [closeCallback, id]);
  const closeButton = (0, _react.useMemo)(() => {
    if (closeEnabled) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        variant: "text",
        color: "inherit",
        size: "small",
        tabIndex: 0,
        "aria-label": closeLabel,
        title: closeLabel,
        onClick: handleCloseNotification,
        ...getTestIdProps(_types.TestId.CloseNotificationButton),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
      });
    }
    return null;
  }, [closeEnabled, closeLabel, getTestIdProps, handleCloseNotification]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    severity: severity,
    variant: "standard",
    action: closeButton,
    ...getTestIdProps(_types.TestId.NotificationMessage),
    children: [text, ' ', linkText && linkUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      href: linkUrl,
      color: "inherit",
      ...getTestIdProps(_types.TestId.NotificationMessageLink),
      children: linkText
    }) : null]
  });
};
exports.Notification = Notification;